import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaRocket, FaArrowRight, FaPhone, FaEnvelope } from 'react-icons/fa';
import './CTA.css';

const CTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.querySelector('.cta-section');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <section className="cta-section section">
      <div className="cta-background">
        <div className="cta-overlay"></div>
      </div>
      
      <div className="container">
        <div className={`cta-content ${isVisible ? 'animate-fadeIn' : ''}`}>
          <div className="cta-icon">
            <FaRocket />
          </div>
          
          <h2 className="cta-title">
            Ready to Transform Your Digital Presence?
          </h2>
          
          <p className="cta-description">
            Let's work together to build something amazing. Get in touch with us today 
            and discover how Redfox Digital can help accelerate your business growth 
            with our cutting-edge digital solutions.
          </p>
          
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary cta-btn">
              Get Your Free Quote
              <FaArrowRight className="btn-icon" />
            </Link>
            {/*<a href="tel:+919438439477" className="btn btn-secondary cta-btn" style={{display: "flex", alignItems: "center"}}>
              <FaPhone className="btn-icon" />
              Call Now
            </a>*/}
          </div>
          
          <div className="cta-contact-info">
            <div className="cta-contact-item">
              <FaPhone className="cta-contact-icon" />
              <div className="cta-contact-details">
                <span className="cta-contact-label">Call Us</span>
                <span className="cta-contact-value">+91 7438037542</span>
              </div>
            </div>
            
            <div className="cta-contact-item">
              <FaEnvelope className="cta-contact-icon" />
              <div className="cta-contact-details">
                <span className="cta-contact-label">Email Us</span>
                <span className="cta-contact-value">redfoxdotin@gmail.com</span>
              </div>
            </div>
          </div>
          
          <div className="cta-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Free Consultation</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Custom Solutions</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>24/7 Support</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>No Hidden Costs</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;